import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import Layout from "../components/Layout";
import { PageHeader, EmptyState } from "../components/UI";

export default function ActivityLogs() {
  const [logs, setLogs] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    // RLS restricts this table's SELECT to super_admin / company_admin roles
    // only (see schema.sql `activity_select` policy) — a manager or operator
    // hitting this page simply gets an empty result, not an error.
    supabase
      .from("activity_logs")
      .select("*")
      .order("created_at", { ascending: false })
      .limit(200)
      .then(({ data, error }) => {
        if (error) setErr(error.message);
        else setLogs(data || []);
      });
  }, []);

  return (
    <Layout>
      <PageHeader title="Activity Logs" subtitle="Audit trail of actions taken in your company" />
      {err && <div className="text-sm text-red-600 mb-3">{err}</div>}
      {logs.length === 0 ? <EmptyState title="No activity yet" /> : (
        <div className="lt-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase text-slate-600">
              <tr>
                <th className="text-left px-4 py-2.5">When</th>
                <th className="text-left">User</th>
                <th className="text-left">Action</th>
                <th className="text-left">Entity</th>
                <th className="text-left">Details</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-t hover:bg-slate-50">
                  <td className="px-4 py-2.5 text-slate-600 whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="text-slate-700">{l.user_email}</td>
                  <td><span className="px-2 py-0.5 rounded bg-slate-100 text-xs">{l.action}</span></td>
                  <td className="text-slate-600">{l.entity}</td>
                  <td className="text-slate-500">{l.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  );
}
